import { AsGrid } from '@adserve/adserve-react-components';
import React, { useContext, useEffect } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { defaultPageInfo } from '../../../services/AsGridService';
import { sectionedPanelStyle } from '../CampaignStyles';
import { campaignPropertyColumnDefinition } from './CampaignPropertyGridColumnDefinitions';
import { sectionTitleStyle } from './ShowStyles';
import { GetCampaignProperties } from '../../../services/CampaignsDataService';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';

const CampaignPropertiesPanel = ({ campaign, onDeleteProperty, readOnly = false }) => {
    const { dateFormat } = useContext(SystemSettingsContext);
    const { campaignProperties, setCampaignProperties } = useContext(AirtimePlanningContext);

    useEffect(() => {
        GetCampaignProperties(campaign.id).then((data) => {
            setCampaignProperties(data);
        });
    }, [campaign]);
    const handleQuoteClick = (e) => {
        const id = e.target.getAttribute('data-id');
        const campaignProperty = { ...campaign.campaignProperties?.find((c) => c.id === id) };
        campaignProperty.quote = !campaignProperty.quote;

        setCampaignProperties([...campaignProperties]);
    };

    const handlePrimaryColumnClick = () => {
        alert('clicked');
    };
    const handleIconDisabilty = () => {
        return false;
    };
    const handleActionClick = (a, b) => {
        if (a === 'delete') {
            onDeleteProperty(b.id);
        }
    };
    return (
        campaignProperties?.length > -1 && (
            <div style={{ ...sectionedPanelStyle, border: '1px solid white', padding: '20px 40px 40px' }}>
                <div style={{ marginLeft: 21 }}>
                    <span style={sectionTitleStyle}>{window.translate('Campaign Properties')}</span>
                </div>

                <div style={{ marginLeft: 21 }}>
                    <div id='grid'>
                        <AsGrid
                            style={{
                                borderLeft: '1px solid rgb(215, 215, 215)'
                            }}
                            maxVisibleRows={campaignProperties.length + 1}
                            showColumnFilter={false}
                            locale='en-GB'
                            currency='GBP'
                            dateFormat={dateFormat}
                            headerRowHeight={53}
                            pageInfo={defaultPageInfo}
                            columnDefs={campaignPropertyColumnDefinition(handleQuoteClick, readOnly)}
                            data={campaignProperties}
                            primaryColumn='propertyName'
                            onPrimaryColumnClick={handlePrimaryColumnClick}
                            onActionIconLoad={handleIconDisabilty}
                            onActionClick={handleActionClick}
                            maxDataRows={5}
                            maxHeight={150}
                        />
                    </div>
                </div>
            </div>
        )
    );
};

export default CampaignPropertiesPanel;
